module.exports = __webpack_public_path__ + "img/img20.ba8add0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img20.png
// module id = 261
// module chunks = 0